import React, { useState, useReducer, useEffect } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, isNotEmpty, throwErrorEvent } from '../../lib/ep.js';
import { size as _size } from 'lodash';

import TextArea from '../../components/builder/TextArea';
import ActionButton, { BackButton, SecondaryButton } from '../../components/builder/ActionButton';
import ButtonCollection from '../../components/builder/ButtonCollection';
import Checkbox from '../../components/builder/Checkbox';
import ConfirmButton, { DeleteButton } from '../../components/builder/ConfirmButton';
import FileUploader from '../../components/builder/FileUploader';
import Message, { AlertMessage } from '../../components/builder/Message';
import Model from '../../components/builder/Model';
import SectionTitle from '../../components/builder/SectionTitle';
import SaveButton from '../../components/builder/SaveButton';
import SectionSubtitle from '../../components/builder/SectionSubtitle';
import Select from '../../components/builder/Select';
import Tooltip from '../../components/builder/Tooltip';
import ToggleButton from '../../components/builder/ToggleButton';
import { PreviewTable } from '../backend/TriviaBulkCreate.js';

const BulkFromFile = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const max_rows_in_preview = props?.max_rows_in_preview ?? 12;
	const max_insert =  props?.max ?? 500;
	const display_manage_actions =  props?.display_manage_actions ?? false;
	const disable_submit =  props?.disable_submit ?? false;
	const max_cols_x_row = 9999999999999
	const block_items = props?.already ?? [];
	const in_floating = props?.in_floating ?? true;

	const [text, setText] = useState(props?.text ?? '');
	const [file, setFile] = useState(false);
	const [disabled_items, setDisabledItems] = useState(block_items);
	const [display_table, setDisplayTable] = useState(false);
	const [display_combine_fields, setDisplayCombineFields] = useState(false);
	const [type_import, setTypeImport] = useState(props?.type_import ?? 'clipboard');

	let fields_init = props?.fields || [];
	fields_init.map((f, i) => {
		const default_position = fields_init[i].regexp == undefined ? 1 : -1;
		fields_init[i].position = fields_init[i]?.position ?? default_position;
	})

	const [state, dispatch] = useReducer((state, action) => {
		switch(action.type){
			case 'SET_ERRORS':
				return { ...state, errors:action.errors };

			case 'CHANGE_POSITIONS':
				return { ...state, fields:action.fields };

			case 'CHANGE_FILE_CONTENT':
				return { ...state, file_content:action.file_content };

			case 'CHANGE_SELECTED':
				return {
					...state,
					fields:state.fields.map(field=>{
						if (field.name != action.k) return field;
						return {
							...field,
							position:action.v
						}
					})
				}

			default:
				return state;
		}
	}, {
		file_content:{col_separator:'tab', headers:[], has_headers:true,file:[] },
		fields:fields_init,
		errors:[],
	});

	const detectFieldPositions = (content) => {
		const rows = content.file;
		if (!rows || rows.length === 0) return {};
		const col_separator = getColSeparator(content.col_separator);
		const numCols = rows[0].split(col_separator).length;
		const dataRows = content.has_headers ? rows.slice(1) : rows; // Ignorem la capçalera

		let detectedPositions = state.fields;

		detectedPositions.forEach((field,fieldIndex) => {
			detectedPositions[fieldIndex].position = detectedPositions[fieldIndex].regexp == undefined ? 1 : -1;

			if (!field.regexp/* && !field.max_length*/) return; // només processem si té regexp o be ja ha estat assignat a una altra fila
			detectedPositions[fieldIndex].allowed = [];
			for (let col = 0; col < numCols; col++) {
				let allMatch = true;
				if(field.regexp){
					allMatch = dataRows.every(row => {
						const row_content = row.split(col_separator);
						const cell = row_content[col]?.trim();
						return cell && field.regexp.test(cell);
					});
				}

				if(field.function){
					allMatch = dataRows.every(row => {
						const row_content = row.split(col_separator);
						const cell = row_content[col]?.trim();
						console.log(col,field.function(cell),cell)
						return cell && field.function(cell);
					});
				}
				
				/*let errorLength = false;
				if(allMatch && field.max_length != undefined){
					errorLength = dataRows.every(row => {
						const row_content = row.split(col_separator);
						const cell = row_content[col]?.trim();
						return cell && cell.length > field.max_length;
					});
					if(errorLength)errorLength = props.intl.formatMessage({ id:"{label} cannot exceed {length} characters" }, { label:field.label,length:field.max_length });
				}*/

				if (allMatch) {
					const _position = col + 1;//Posem sempre una posicio perque safegeix a davant l'index de la fila
					detectedPositions[fieldIndex].allowed.push(_position);
					detectedPositions[fieldIndex].position = _position;
					//detectedPositions[fieldIndex].error = errorLength;
					return; // sortim quan trobem la primera columna que matxa
				}
			}
		});

		//Assignacio on posem per defecte main_field el valor de email_field per facilitar la seleccio
		const has_email_field = (state.fields).find(f => f.name === 'email_field' && f.position >= 0 && isNotEmpty(f,'position'));
		if(has_email_field){
			const index_of_main_field = (state.fields).indexOf((state.fields).find(f => f.name === 'main_field'));
			if(index_of_main_field >= 0 && has_email_field.position)detectedPositions[index_of_main_field].position = has_email_field.position;
		}
		dispatch({ type:'CHANGE_POSITIONS', fields:detectedPositions});
	}

	useEffect(()=>{
		detectFieldPositions(state.file_content)
	},[state.file_content.col_separator])

	const changeFileContent = (k, v) => {
		let file_content = state.file_content;
		file_content[k] = v;
		dispatch({ type:'SET_ERRORS', errors:[]});
		dispatch({ type:'CHANGE_FILE_CONTENT', file_content});
		formatCSVFile(file_content);
	};

	const changeFields = (k, v) => {
		dispatch({ type:'SET_ERRORS', errors:[]});
		dispatch({ type:'CHANGE_SELECTED', k,v});
		formatCSVFile(state.file_content, true);
	};

	const getColSeparator = (separator) => {
		var col_sep = '\t';

		switch(separator) {
			case 'semicolon':
				col_sep = ';';
				break;

			case 'colon':
				col_sep = ',';
				break;

			case 'tab':
			default:
				col_sep = '\t';
				break;
		}

		return col_sep;
	}

	const b64_to_utf8 = (str) => {
		str = str.replace(/\s/g, '');
		try {
			return decodeURIComponent(escape(window.atob(str)));
		} catch (error) {
			try {
				return unescape(atob(str));
			} catch (error) {
				return true;
			}
		}
	};

	const resetFiles = (_type_import) => {
		setTypeImport(_type_import ?? (props?.type_import ?? 'clipboard'));
		setText(props?.text ?? '');
		setFile(false);
	};

	const resetValues = () => {
		let file_content = state.file_content;
		file_content.num_combined_fields = 0;
		file_content.col_separator = 'tab';
		file_content.headers = [];
		file_content.has_headers = (type_import == 'clipboard') ? false : true;
		file_content.file = [];
		dispatch({ type:'CHANGE_FILE_CONTENT', file_content});
	};

	const formatCSVFile = (file_content, skip_autodetect) => {
		var f_extract = [];
		var f_headers = [];
		const col_sep = getColSeparator(file_content.col_separator);

		var remove_index = 0;
		if(file_content.remove_index != undefined && file_content.remove_index > 0) {
			remove_index = file_content.remove_index;
			var remove_results = [];
			$.each(file_content.file, (i, item) => {
				var tnn = item.split(col_sep);
				tnn.splice(remove_index - 1, 1)
				file_content.file[i] = tnn.join(col_sep);
			});
			delete file_content.remove_index;
		}

		file_content.execute_combination = (file_content.execute_combination == undefined) ? false : file_content.execute_combination;
		if(file_content.execute_combination) executeCombination(col_sep);

		if(file_content.has_headers) {
			var splice_ini = 1;
			var headers = file_content.file.slice(0, 1);
			var tmp2 = [];
			$.each(headers, (i, item) => {
				var tmp = (i+1) + col_sep + item;
				f_headers.push(tmp.split(col_sep));
				tmp2.push(item.split(col_sep)); //NO NUMBER INITIAL
			});
			file_content.headers = tmp2[0];
		} else {
			var splice_ini = 0;
			f_headers = false;
			file_content.headers = false;
		}

		var results = file_content.file.slice(splice_ini, splice_ini + max_rows_in_preview);

		const trimChar = (string, charToRemove) => {
			while(string.charAt(0) == charToRemove) {
				string = string.substring(1);
			}

			while(string.charAt(string.length - 1) == charToRemove) {
				string = string.substring(0, string.length - 1);
			}

			return string;
		}
		
		//Email field detect
		/*var tmp_email_field = [];
		var coincidencia_index = false;

		var first_load = false;
		if(file_content.email_field == null) first_load = true;

		file_content.email_field = null;
		var num_coincidencies_per_index = 0;
		var email_field_indexs = [];
		var telephone_fields_indexs = [];
		var pattern_telephone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;

		$.each(results, (i, item) => {
			tmp_email_field = item.split(col_sep);
			$.each(tmp_email_field, (j, jtem) => {
				jtem = trimChar(jtem.trim(), '"');
				jtem = trimChar(jtem.trim(), "'");

				if(validateEmail(jtem.trim())) {
					if(file_content.email_field == null) {
						file_content.email_field = j + 1;
						num_coincidencies_per_index=1;
						coincidencia_index = true;
						email_field_indexs[file_content.email_field] = true;
					} else if(file_content.email_field != j + 1) {
						coincidencia_index = false;
					} else {
						num_coincidencies_per_index += 1;
					}

					if(email_field_indexs[(j + 1)] == undefined || !email_field_indexs[(j + 1)]) {
						email_field_indexs[(j + 1)] = true;
					}

					return true;
				} else {
					email_field_indexs[(j + 1)] = false;
				}

				if(pattern_telephone.test(jtem.trim()) && _size(jtem.trim()) > 5) {
					if(telephone_fields_indexs[(j + 1)] == undefined || !telephone_fields_indexs[(j + 1)]) {
						telephone_fields_indexs[(j + 1)] = true;
					}
				} else {
					telephone_fields_indexs[(j + 1)] = false;
				}
			});
			if(!coincidencia_index) return true;
		});

		if(num_coincidencies_per_index == results.length) {
			if(first_load) file_content.main_field = file_content.email_field;
		} else {
			//file_content.main_field = 1;
			file_content.email_field = null;
		}*/


		var size = file_content.file.length - splice_ini;
		var tmp = '';
		let counter = 0;
		$.each(results, function(i, item) {
			const re = new RegExp(col_sep, 'g');
			const tmp_item = item.replace(re, '');
			if(tmp_item.length >= 1){
				var tmp = (counter+1) + col_sep + item;
				f_extract.push(tmp.split(col_sep));
				counter++;
			}
		});

		var obj = {};
		obj.f_extract = f_extract;
		obj.f_headers = f_headers;

		const total_lines = file_content.file.length;
		if(total_lines > max_rows_in_preview) {
			if(total_lines > (max_rows_in_preview + 1)) {
				var foo = [];
				for(var i = 0; i < f_extract[0].length; i++) foo.push('...');
				f_extract.push(foo);
			}
			var last_element = file_content.file.slice(-1).pop();
			var tmp = size + col_sep + last_element;
			f_extract.push(tmp.split(col_sep));
		}

		//Set combination available
		obj.num_combined_fields = _.size(file_content.combine_fields_index);

		obj.combination_available = ( _.size(f_extract[0]) > 2) ? true : false;

		const merged_all  =  {...file_content, ...obj};
		file_content = merged_all;

		if(props.onImportParticipants != undefined) {
			props.onImportParticipants({
				num_cols:(file_content?.f_extract?.[0] ?? []).length - 1,
				num_rows:(file_content.has_headers) ? file_content.size - 1 : file_content.size,
			});
		}
		dispatch({ type:'CHANGE_FILE_CONTENT', file_content});
		if(skip_autodetect == undefined)skip_autodetect = false;
		if(!skip_autodetect)detectFieldPositions(file_content);
	};

	const executeCombination = (col_sep) => {

		let file_content = state.file_content;

		$.each(file_content.file, (i, item) => {
			var tmp_row = item.split(col_sep);
			tmp_row = combinePositions(tmp_row, file_content.combine_fields_index);
			file_content.file[i] = tmp_row.join(col_sep);
		});

		file_content.combine_fields = false;
		file_content.combine_fields_index = [];
		file_content.combination_posible = false;
		file_content.execute_combination = false;

		//dispatch({ type:'CHANGE_FILE_CONTENT', file_content});

		formatCSVFile(file_content);
	}

	const toggleCombineFields = () => {
		setDisplayCombineFields(!display_combine_fields);

		let file_content = state.file_content;
		file_content.combine_fields = !display_combine_fields;
		file_content.combine_fields_index = [];
		file_content.combination_posible = false;
		file_content.execute_combination = false;
		file_content.num_combined_fields = 0;
		formatCSVFile(file_content);
	};

	const combineFields = () => {
		let file_content = state.file_content;
		file_content.main_field = 1;
		file_content.visualization_field = 1;
		file_content.email_field = null;
		file_content.numeric_field = null;
		file_content.execute_combination = true;
		file_content.num_combined_fields = 0;
		formatCSVFile(file_content);
	};

	const combinePositions = (elements, positions) => {
		var tmp_elements = [];
		var new_elements = [];
		var position_to_set = null;

		$.each(positions, (i, item) => {
			if(position_to_set == null) position_to_set = item - 1;
			elements[position_to_set] = (i != 0) ? elements[position_to_set] + ' ' + elements[item - 1] : elements[item - 1];
			if(i != 0) elements[item - 1] = 'to_set_null';
		});

		$.each(elements, function(j, jtem) {
			if(jtem != 'to_set_null') new_elements.push(jtem);
		});

		return new_elements;
	};

	const addFieldToCombine = (index) => {
		let file_content = state.file_content;

		var array_tmp = file_content.combine_fields_index;
		var founded = array_tmp.indexOf(index);

		if(founded == -1) {
			array_tmp.push(index);
		} else {
			array_tmp.splice(founded,1);
		}

		file_content.combine_fields_index = array_tmp;
		file_content.combination_posible = (_size(file_content.combine_fields_index) > 1) ? true : false;

		// dispatch({ type:'CHANGE_FILE_CONTENT', file_content});

		formatCSVFile(file_content);
	};

	const deleteFields = (index) => {
		let file_content = state.file_content;
		file_content.remove_index = index;
		formatCSVFile(file_content);
	};

	const upload = (cb) => {
		//It good formating
		var string_file = '';
		if(props.import_from_ai){
			let json_data = text;//es un JSON
			let result = [];
			json_data.map((item,i) => {
				result.push(item.join("\t"));
			})
			string_file = result.join("\n")
		}else{
			if(type_import == 'upload') {
				var arr = file.split(',');
				string_file = b64_to_utf8(arr[1]);
			} else {
				string_file = text;
			}
			
		}
		let file_content = state.file_content
		string_file = string_file.replace(/['"]+/g,'');
		file_content.file = string_file.split("\n").slice(0,max_insert + 1);
		
		var size = 0;
		var empty_rows=true;
		var file_content_file = [];

		$.each(file_content.file, (i, item) => {
			if(item != undefined) {
				item = item.replace(/\s{2,}/g, ' ');
				item = item.replace(/\t/g, ' ');
				item = item.toString().replace(/(\r\n|\n|\r)/g,"").trim();
				if(item.length >= 1) {
					empty_rows = false;
					size++;
					file_content_file.push(file_content.file[i]);
				}
			}
		});

		if(!empty_rows) {
			resetValues();
			file_content.file = file_content_file;
			file_content.size = size;
			formatCSVFile(file_content);
			resetFiles(type_import);
			setDisplayTable(true);
		} else {
			alert("The file is empty");
		}
		if(cb!=undefined)cb();
	};

	useEffect(() => {
		if(props.import_from_ai) upload();
	},[])

	const checkErrors = (content, cb) =>{

		const rows = content.file;
		if (!rows || rows.length === 0) return {};
		const col_separator = getColSeparator(content.col_separator);
		const numCols = rows[0].split(col_separator).length;
		const dataRows = content.has_headers ? rows.slice(1) : rows; // Ignorem la capçalera

		let detectedPositions = state.fields;
		let errorFields = [];
		console.log('fields',fields)
		detectedPositions.forEach((field,fieldIndex) => {
			if (!field.max_length) return; // només processem si té regexp o be ja ha estat assignat a una altra fila
			for (let col = 0; col < numCols; col++) {
				let errorLength = false;
				if(field.max_length != undefined){
					errorLength = dataRows.every(row => {
						const row_content = row.split(col_separator);
						const cell = row_content[col]?.trim();
						return cell && cell.length > field.max_length;
					});
					if(errorLength && field.position > -1){
						const header_position = parseInt(field.position) - 1
						errorFields[fieldIndex] = `${field.label} - ${fields[header_position].v}: ${props.intl.formatMessage({ id:"limit {length} characters" }, { length:field.max_length })}`;
					}
				}
			}
		});
		dispatch({ type:'SET_ERRORS', errors:errorFields});
		if(cb != undefined)cb(errorFields.length > 0)
	}

	const insert = (cb) => {

		checkErrors(state.file_content, (has_errors) => {
			if(has_errors)return;
			const col_sep = getColSeparator(state.file_content.col_separator);

			var items = [];
			var array_items = [];

			var splice_ini = (state.file_content.has_headers)	? 1 : 0;
			var all = state.file_content.file;
			var results = all.slice(splice_ini, splice_ini + all.length);
			all = null;
			results.map((item,i) => {
				const re = new RegExp(col_sep, 'g');
				const tmp_item = item.replace(re, '');
				
				if(disabled_items.includes(i))return;

				if(tmp_item.length >= 1){
					let element_to_insert = {};
					let item_col_separated = item.split(col_sep);
					array_items.push(item_col_separated);
					(state.fields).map((field,j)=>{
						if((!isNotEmpty(field,'position') || field.position < 0) || !(field?.columned ?? true))return;
						let real_position = parseInt(field.position) - 1;
						element_to_insert[field.name] = (item_col_separated?.[real_position] ?? '').trim();
					})
					if(item != undefined) items.push(element_to_insert);
				}
			})
			var items_stringify = JSON.stringify(items);

			const url_post = props?.url_post ?? false;
			
			if(url_post !== false) {
				$.post(url_post, {data:items_stringify}, (result) => {
					if(result.status) {
						if(props.onSuccess != undefined){
							setDisplayTable(false);
							resetValues();
							props.onSuccess(result.vs);
						}
					} else {
						alert("ERROR");
					}
					if(cb != undefined) cb();
				}, 'JSON').fail((xhr, ajaxOptions, thrownError) => {
					throwErrorEvent(xhr.status);
				});;
			}else{
				if(props.onSuccess != undefined){
					setDisplayTable(false);
					resetValues();
					props.onSuccess(items);
					if(cb != undefined) cb();
				}
				
				if(props.onSuccessList != undefined){
					let config = {};
					state.fields.forEach(item => config[item.name] = item.position);
					config.headers = state.file_content.headers
					props.onSuccessList(array_items,config);
					if(cb != undefined) cb();
				}
			}
		});
		if(cb!=undefined)cb();
	}

	if(display_table){
		const content = state.file_content;
		var col_separator = [
			{ k:'tab', v:i18n("Tabulation") },
			{ k:'semicolon', v:i18n("Semi-colon") },
			{ k:'colon', v:i18n("Comma") },
		];

		var fields = [];
		const total_questions = content?.f_extract?.length ?? 0;

		if(content.f_headers) {
			content.f_headers.map((row1, i) => {
				if(i == 0) {
					row1.map((row2, j) => {
						if(j > 0) {
							var value = '';
							if(cleanString(row2)!=''){
								value = cleanString(row2);
							}else{
								value = props.intl.formatMessage({ id:"Column #{column}" }, { column:(j) });
							}
							fields.push({ k:j, v:value });
						}
					});
				}
			});
		} else if(content.f_extract) {
			content.f_extract.map((row1, i) => {
				if(i == 0) {
					row1.map((row2, j) => {
						if(j > 0) {
							fields.push({ k:j, v:props.intl.formatMessage({ id:"Column #{column}" }, { column:(j) }) });
						}
					});
				}
			});
		}
		const disable_confirm = Math.max(disabled_items.length,block_items.length) == total_questions || state.errors.length > 0; 
		if(props.import_from_ai) {
			return (
				<>
					<PreviewTable
						content={content}
						enable_add={true}
						row_icon={props?.icon ?? "knk-anagram"}
						column_ok_icon={false}
						column_ko_icon={false}
						column_defs='4ch 1fr 1fr 100px'
						intl={props.intl}
						onChangeStatus={(items)=>setDisabledItems(items)}
						block_items={block_items}
					/>

					{(props.extra_msg != undefined) && (
						props.extra_msg
					)}

					<ButtonCollection in_floating={true}>
						<SaveButton
							type="confirm"
							_position={props?.tooltip_confirm_position ?? 'bottomright'}
							confirmMessage="Confirm before starting the import process"
							onClick={(e, cb) => disable_confirm ? null : insert(cb)}
							disabled={disable_confirm}
						>{props?.confirm_label ?? "Continue"}</SaveButton>

						<BackButton
							_position="bottomright"
							onClick={() => {
								resetValues();
								if(props.close == undefined) {
									setDisplayTable(false);
								} else {
									props.close(true);
								}
							}}
						/>
					</ButtonCollection>
				</>
			)
		}
		const disable_title = props?.disable_title ?? false;
		return (
			<div class={(in_floating) ? 'gui_is_padded' : null}>
				{(!disable_title) && (
					<SectionTitle _class={{other:'in_top'}}>Preview</SectionTitle>
				)}
				<Model model={state.file_content} change={changeFileContent}>
					{(type_import != 'clipboard') && (
						<Checkbox
							name="has_headers"
							_class={{ first:true }}
							model={state.file_content} 
							change={changeFileContent}
						>Imported file has headers</Checkbox>
					)}

					<Select
						name="col_separator"
						values={col_separator}
						_class={{ size:50 }}
					>Columns are delimited by</Select>
				</Model>


				<div id="file_content" class="with_actions">
					<div class="input">
						{(content.combination_available && display_manage_actions) && (
							(content.combine_fields) ? (
								<ButtonCollection 
									_class={{other:'not_in_bottom'}}
								>
									<ConfirmButton
										disabled={(!content.combination_posible) ? true : false}
										color={(!content.combination_posible) ? 'gray' : 'green'}
										icon='knk-on'
										onClick={() => combineFields()}
										autotranslate={false}
									>{props.intl.formatMessage({id:"Combine {num} columns"}, { num:content.num_combined_fields })}</ConfirmButton>

									<SecondaryButton
										onClick={() => toggleCombineFields()}
									>Close</SecondaryButton>
								</ButtonCollection>
							) : (
								<ButtonCollection
									_class={{other:'not_in_bottom'}}
								>
									<ActionButton
										icon='knk-group-element'
										onClick={() => toggleCombineFields()}
									>Manage columns</ActionButton>
								</ButtonCollection>
							)
						)}

						<div class="file_preview" style={{maxHeight:'40svh'}}>
							<div class="table_content">
								<ul>
									{(content.combine_fields) && (
										<div>
											{content.f_extract.map((row1, i) => {
												if(i == 0) {
													return row1.map((row2, j) => {
														const active = (content.combine_fields_index.find((o) => (o == j)) >= 0) ? true : false;
														return (
															<li class={"checker_table_head" + (j==0 ? ' row_id' : '')} key={'actions'+j}>
																{(j!=0) && (
																	<ButtonCollection _class={{other:'gui_flex_center'}}>
																		<ToggleButton
																			squared={true}
																			active={active}
																			tooltip={<Tooltip with_icon={false} position="top">{(active) ? "Uncheck to leave as independent field" : "Check to combine"}</Tooltip>}
																			color="black"
																			icon='knk-checkbox-on'
																			icon_off='knk-checkbox-off'
																			_class={{first:true, other:'main_text_color_icon'}}
																			onClick={() => addFieldToCombine(j)}
																		/>

																		<DeleteButton
																			squared={true}
																			onClick={() => deleteFields(j)}
																			tooltip={<Tooltip with_icon={false} position="top">Delete field</Tooltip>}
																		/>
																	</ButtonCollection>
																)}
															</li>
														)
													})
												}
											})}
										</div>
									)}

									<div class="thead">
										<li />

										{(content.f_headers) ? (
											content.f_headers.map((row1, i) => {
												return row1.map((row2, j) => {
													if(j > max_cols_x_row) return null;

													let _classes = ['whiteIcon', 'whiteColor'];
													if(j == 0) _classes.join('row_id');
													if(content.combine_fields && content.combine_fields_index.find((o) => (o == j)) >= 0) {
														_classes.push('disabledItem');
													}
													let clss = _classes.join(' ');
													var value_col = (cleanString(row2) != '') ? row2 : props.intl.formatMessage({ id:"Column #{column}" }, { column:j });

													if(j !== 0) {
														return (
															<li class={clss} key={`header${j}`}>
																<span>{value_col}</span>

																{state.fields.map((field, f) => {
																	if(field.position != j) return null;
																	if(!(field?.columned ?? true))return null;
																	let icon = field?.icon || 'knk-object';
																	let _tooltip = field.label;
																	if(field.name == 'email_field')_tooltip = field.tooltip;
																	return (
																		<Tooltip
																			key={`tt_${f}`}
																			position="top"
																			icon={`${icon} gui_small_icon`}
																		>{_tooltip}</Tooltip>
																	)
																})}
															</li>
														)
													}
												})
											})
										) : (
											content.f_extract && content.f_extract.map((row1, i) => {
												if(i == 0) {
													return row1.map((row2, j) => {
														if(j > max_cols_x_row) return null;

														let _classes = ['whiteIcon', 'whiteColor'];
														if(j == 0) _classes.push('row_id');
														if(content.combine_fields && content.combine_fields_index.find((o) => (o == j)) >= 0) {
															_classes.push('disabledItem');
														}

														if(j !== 0) {
															return (
																<li key={`header${j}`} class={_classes.join(" ")}>
																	<span>
																		<FormattedMessage id="Column #{column}" values={{column:(j)}} />
																	</span>

																	{(state.fields.map((field, f) => {
																		if(field.position != j)return null;
																		if(!(field?.columned ?? true))return null;
																		let icon = field?.icon || 'knk-object';
																		let _tooltip = field.label;
																		if(field.name == 'email_field')_tooltip = field.tooltip;
																		return (
																			<Tooltip
																				key={`tt_${f}`}
																				position="top"
																				icon={`${icon} gui_small_icon`}
																			>{field.label}</Tooltip>
																		)
																	}))}
																</li>
															)
														}
													})
												}
											})
										)}
									</div>

									{content.f_extract && content.f_extract.map((row1, i) => {
										return (
											<div key={i}>
												{row1.map((row2, j) => {
													if(j > max_cols_x_row) return null;

													let _classes = [];
													if(j == 0) _classes.push('row_id');
													if(content.combine_fields && content.combine_fields_index.find((o) => (o == j)) >= 0) {
														_classes.push('disabledItem');
													}

													return (
														<li key={`id${j}`} class={_classes.join(" ")}>{row2}</li>
													)
												})}
											</div>
										)
									})}
								</ul>
							</div>
						</div>
					</div>
				</div>

				{(state.errors.length > 0) && (
					<AlertMessage 
						title="Error"
						_class={{ other:'tip_message' }}>
						<p class="gui_underlined_text">{`${i18n("Some records exceed the character length limit")}:`}</p>
						<ul>
							{(state.errors).map((item)=>{
								return (
									<li>{item}</li>
								)
							})}
						</ul>
						<p class="gui_not_in_top_small"><strong>{i18n("Solution")}</strong>:<br/>{i18n("Check whether you have selected the correct separator or review the length of the records in the column.")}</p>	
					</AlertMessage>
				)}

				{(state.fields.length > 0) && (
					<div class="gui_not_in_top_huge">
						<SectionTitle>Match columns to import</SectionTitle>

						<Model model={state.fields} change={(k, v) => changeFields(k, v)}>
							{(state.fields).map((select_field, i) => {

								let filtered_fields = fields.filter(field => {
															if ((!select_field.allowed || select_field.allowed.length == 0) && !select_field.regexp) return true;
															return (select_field?.allowed ?? []).includes(field.k);
														});
								if(filtered_fields.length == 0) return null;
								//casuistica per sorteo listado
								if(select_field.name == 'additional_participations'){
									if((state.fields).find(f => f.name === 'numeric_field' && f.position >= 0 && isNotEmpty(f,'position'))) {
										filtered_fields = [
											{ k:0, v:"Assign the number of entries of the first record" },
											{ k:1, v:"Sum the number of entries of each record" },
											{ k:2, v:"Assign the number of entries of higher value" },
											{ k:3, v:"Assign the number of entries of lower value" },
										];
									} else {
										filtered_fields = [
											{ k:0, v:"Give only 1 participation" },
											{ k:1, v:"Give 1 extra participation for each record" },
										];
									}
								}else if(select_field.name == 'numeric_field'){
									filtered_fields.unshift({ k:-1, v:i18n("No additional participations field") });
								}else if(select_field.name == 'email_field')return null;

								return (
									<Select
										key={`field_${i}`}
										_class={{size:60}}
										label_props={{
											_class:{ icon:select_field?.icon ?? 'knk-text' },
											autotranslate:false,
											tooltip:select_field.tooltip ? <Tooltip>{select_field.tooltip}</Tooltip> : null
										}}
										name={select_field.name}
										value={select_field.position}
										values={filtered_fields}
										after_component={select_field?.after_component ?? null}
										autotranslate={!(state.file_content?.has_headers ?? false)}
									>{select_field?.label ?? i18n("Field")}</Select>
								)
							})}
						</Model>
					</div>
				)}

				<ButtonCollection 
					in_floating={in_floating}
					_class={(in_floating === false) ? { other:'not_in_top gui_flex_row_reverse' } : null}
				>	
					{(props.extra_button != undefined) && (
						<>{props.extra_button}</>
					)}
					
					<SaveButton
						type="confirm"
						_position={props?.tooltip_confirm_position ?? 'bottomright'}
						confirmMessage="Confirm before starting the import process"
						onClick={(e, cb) => insert(cb)}
						disabled={disable_submit}
					>Continue</SaveButton>

					<BackButton
						_position="bottomright"
						onClick={(e, cb) => {
							resetValues();
							setDisplayTable(false);
							if(props.close != undefined)props.close(false);
						}}
					/>
				</ButtonCollection>
			</div>
		)
	}

	const title = props?.title ?? "Import items";
	let subtitle = props?.subtitle ?? "You can import up to {max} items in bulk.";
	if(isNotEmpty(props,'subtitle_clipboard') && type_import == 'clipboard')subtitle = props.subtitle_clipboard;
	if(isNotEmpty(props,'subtitle_upload') && type_import == 'upload')subtitle = props.subtitle_upload;

	const instructions = props?.instructions ?? false;
	const disabled_import = (!file && type_import == 'upload' || !text && type_import == 'clipboard') || (props?.disabled_import ?? false);
	const disable_title = props?.disable_title ?? false;
	
	return(
		<div class={(in_floating) ? 'gui_is_padded' : null}>
			{(!disable_title) && (
				<SectionTitle _class={{other:'in_top'}}>{title}</SectionTitle>
			)}

			{(subtitle !== false) && (
				<SectionSubtitle autotranslate={false}>
					<p dangerouslySetInnerHTML={{ __html:props.intl.formatMessage({id:subtitle}, {max:<strong>{max_insert}</strong>})}}></p>
				</SectionSubtitle>
			)}

			{(instructions !== false) && (
				<Message
					title="Instructions"
					icon='knk-tip'
					_class={{ other:'in_top' }}
				>
					{instructions}
				</Message>
			)}

			<Select
				_class={{align:'row', width:50}}
				values={[{ k:'upload', v:"CSV file" }, { k:'clipboard', v:"Copy/paste from a file" }]}
				value={type_import}
				change={(k, v) => setTypeImport(v)}
			>Select the method to import</Select>

			{(type_import == 'upload') && (
				<FileUploader
					model={file}
					small_input={true}
					display_custom_dragging_instructions="Upload file"
					name="file"
					allowed={{
						'text/csv':1,
						'text/plain':1,
						'text/x-csv':1,
						'application/csv':1,
						'application/x-csv':1,
						'text/comma-separated-values':1,
						'text/x-comma-separated-values':1,
						'text/tab-separated-values':1,
						'application/vnd.ms-excel':1,
					}}
					_accepted_formats={["CSV", "TXT"]}
					_max_weight={100}//MB
					change={(k, v) => setFile(v)}
				>Upload file</FileUploader>
			)}

			{(type_import == 'clipboard') && (
				<TextArea
					_class={{v_size:'normal', contents:'code'}}
					value={text}
					name="clipboard"
					change={(k, v) => setText(v)}
					_focus={props?.autofocus ?? true}
				>Copy text</TextArea>
			)}

			{(type_import != null) && (
				<ButtonCollection
					in_floating={in_floating}
					_class={(in_floating === false) ? { other:'not_in_top gui_flex_row_reverse' } : null}
				>

					{(props.extra_button != undefined) && (
						<>{props.extra_button}</>
					)}
					
					<SaveButton
						disabled={disabled_import}
						onClick={(e,cb) => upload(cb)}
					>{props?.import_label ?? "Import"}</SaveButton>

					{(props.close != undefined) && (
						<SecondaryButton
							onClick={props.close}
						>Close</SecondaryButton>
					)}
				</ButtonCollection>
			)}
		</div>
	)
};

export default injectIntl(BulkFromFile);